"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteTemplateFavourite_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NoteTemplateFavourite_Factory = /** @class */ (function () {
    function NoteTemplateFavourite_Factory() {
    }
    NoteTemplateFavourite_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            NoteTemplateId: model.NoteTemplateId,
            RecordId: model.RecordId,
            UserId: model.UserId,
        };
        return result;
    };
    NoteTemplateFavourite_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            NoteTemplateId: model.NoteTemplateId,
            RecordId: model.RecordId,
            UserId: model.UserId,
        };
        return result;
    };
    return NoteTemplateFavourite_Factory;
}());
exports.NoteTemplateFavourite_Factory = NoteTemplateFavourite_Factory;
